import React, { Component } from 'react';
import { Col, ControlLabel, Form, FormGroup } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import './ChangeOrderQuoteRequestForm.css';
import Date from 'components/shared/text/Date';
import FormDateTimePicker from 'components/shared/form/FormDateTimePicker';
import { todayValidation } from 'services/utils/date-util';

class ChangeOrderQuoteRequestForm extends Component {
  render() {
    return (
      <div className="change-order-quote-request-form">
        <Form horizontal onSubmit={this.props.handleSubmit}>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={4}>
              Contractor
            </Col>
            <Col sm={8}>
              <span className="body-bold">
                {this.props.currentTask.contractorName}
              </span>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={4}>
              Target Completion Date
            </Col>
            <Col sm={8}>
              <span className="body-bold">
                <Date
                  format="LL"
                  value={this.props.changeOrderTask.completion_date}
                />
              </span>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={4}>
              Pricing Due Date
            </Col>
            <Col sm={8}>
              <Field
                component={FormDateTimePicker}
                isValidDate={todayValidation}
                name="bidDueDate"
                placeholder="Pricing Due Date"
              />
            </Col>
          </FormGroup>
          {this.props.invalid && this.props.submitFailed && (
            <div className="invalid-message">
              The outlined inputs should be added in order to request change
              order pricing.
            </div>
          )}
          <FormGroup className="button-container">
            <Col sm={12}>
              <input
                className="btn button button-orange"
                type="submit"
                value="Submit"
              />
            </Col>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};
  if (!values.bidDueDate) {
    errors.bidDueDate = 'Required';
  }
  return errors;
}

export default reduxForm({
  form: 'ChangeOrderQuoteRequestForm',
  validate,
})(ChangeOrderQuoteRequestForm);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/change-order-quotes/ChangeOrderQuoteRequestForm.js